module.exports = __webpack_public_path__ + "static/FuturaStd-Book-d6af53395da0e204b7c186b5ab30d17d.woff";